import * as ROUTES from '../routes';

const Navigations = [
    {
        title: "App Manager",
        icon: "mdi-application-cog",
        to: ROUTES.APPSETTINGS,
        mini: false,
        permissions: ['can_view_system_settings','can_view_notifications'],
        subNav: [
            {
                title: "System Settings",
                to: ROUTES.APPSETTINGS,
                icon: "mdi-application-cog"
            },
            {
                title: "Notifications",
                to: ROUTES.APPNOTIFICATIONS,
                icon: "mdi-application-cog"
            }
        ]
    },
]

export default Navigations